import { render, staticRenderFns } from "./CustomerLanding.vue?vue&type=template&id=79d428a0&scoped=true"
import script from "./CustomerLanding.vue?vue&type=script&lang=js"
export * from "./CustomerLanding.vue?vue&type=script&lang=js"
import style0 from "./CustomerLanding.vue?vue&type=style&index=0&id=79d428a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d428a0",
  null
  
)

export default component.exports